import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Image from '@empiriecom/module-components/Image';
import getIcon from '@empiriecom/module-components/utils/getIcon';
import { MediaAsset } from '@/src/interfaces';

const ThumbnailContainer = styled.div<{
  active: boolean;
  dim: number;
  margin: number;
  mobile: boolean;
  type: string;
}>`
  display: flex;
  align-items: ${({ type }) => (type === 'CLIPLISTER' ? 'center' : 'flex-start')};
  text-align: center;
  box-shadow: none;
  outline: none;
  margin: 0;
  padding: 0;
  width: ${({ dim }) => dim}px;
  height: ${({ dim }) => dim}px;
  min-width: ${({ dim }) => dim}px;
  min-height: ${({ dim }) => dim}px;
  max-width: ${({ dim }) => dim}px;
  max-height: ${({ dim }) => dim}px;
  cursor: pointer;
  background-color: transparent;
  position: relative;
  margin-left: ${({ margin }) => margin}px;
  border: 0px none;
  ${({ active }) => (active ? 'opacity: 1;' : 'opacity:0.5;')}
  img {
    width: ${({ dim, type }) => (type === 'CLIPLISTER' ? '100%' : `${dim}px`)};
    height: ${({ dim, type }) => (type === 'CLIPLISTER' ? 'auto' : `${dim}px`)};
  }
  &&:first-child {
    ${({ mobile }) => !mobile && 'margin-left: 0;'};
  }
`;

const ThumbOverlay = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PlayIcon = getIcon('Play');

interface ThumbnailProps {
  image: MediaAsset;
  isActive: boolean;
  isMobile: boolean;
  name: string;
  onClick: () => void;
  thumbMargin: number;
  thumbDim: number;
}

export const Thumbnail: FunctionComponent<ThumbnailProps> = ({
  image,
  isActive,
  isMobile,
  name,
  onClick,
  thumbDim,
  thumbMargin,
}): JSX.Element => {
  let element;
  switch (image.type) {
    case 'CLIPLISTER':
      element = (
        <ThumbnailContainer
          active={isActive}
          data-testid="thumbnail"
          dim={thumbDim}
          key={image.url}
          margin={thumbMargin}
          mobile={isMobile}
          onClick={onClick}
          type={image.type}
        >
          <ThumbOverlay>
            <PlayIcon size="2.5rem" color="#fff" />
          </ThumbOverlay>
          <Image alt={name} src={image.url} />
        </ThumbnailContainer>
      );
      break;
    case 'IMAGE':
      element = (
        <ThumbnailContainer
          active={isActive}
          data-testid="thumbnail"
          dim={thumbDim}
          key={image.url}
          margin={thumbMargin}
          mobile={isMobile}
          onClick={onClick}
          type={image.type}
        >
          <Image alt={name} src={`${image.url}?$PDV_gallery$`} />
        </ThumbnailContainer>
      );
      break;
    default:
  }
  return element;
};

export default Thumbnail;
